import type { FaireProductEntity } from "../../entity_types/product";

export const p_7wy9sfvrc6: FaireProductEntity = {
  token: "p_7wy9sfvrc6",
  type: "product",
  name: "Matches in Tin - Cherries",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/76df59b548a4f2a966499f60e780b667cfd6d01da7a2dfecd7d803b57583f02d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/05a119f41750ef4e5a223c546238aad1570dac42ae89aaf64201df8189d7faac.jpeg",
    "https://cdn.faire.com/fastly/be651589d60c07900907c71b62c9c44441dc6cec9d00a89ceb6487a72a3ae8fb.jpeg",
  ],
  priceDollars: 8.5,
  description:
    'These Cherry Safety Matches are housed in a reusable sliding lid tin featuring a pair of vintage-style cherries tied with a delicate ribbon bow. Inspired by nostalgic fruit illustrations and decorative paper ephemera, the playful design blends soft colours and classic motifs to bring a charming touch to everyday spaces.\n\nContaining 100 safety matches with soft pink tips, each tin features striker paper housed within a custom brass holder on the side, combining everyday practicality with timeless decorative design. The sliding lid construction adds a tactile vintage feel, while the reusable tin is designed to be refilled and enjoyed long after the matches are gone. A sweet addition to coffee tables, bedside spaces, and kitchen shelves, it also makes a thoughtful gift for lovers of vintage-inspired interiors and playful design.\n\nContains 100 safety matches. Keep away from children, heat, sparks, and open flames. Store in a dry place.\n\nSize: 12cm H x 8.5cm W x 2.5cm D | 4.72" H x 3.35" W x 0.89" D',
  tags: [],
  msrpDollars: 19,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:36.460Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
